// extracted by mini-css-extract-plugin
export default {"avatar":"QSzwXh","menu":"fUqM3q","popoverContent":"DlKEil","mobileButton":"QpLA2v"};